export default __webpack_public_path__ + "static/media/spil-id-logo.5b5269a6.svg";